const INTERNAL_REASON_LABELS = [
  "TRUE_NO_OP",
  "TARGET_MISMATCH",
  "MODEL_OUTPUT_MISMATCH",
  "APPLY_FAILED",
  "PARTIAL_APPLY",
  "true_no_op",
  "target_mismatch",
  "model_output_mismatch",
  "apply_failed",
  "partial_apply",
  "NO_MODIFICATIONS_RETURNED",
  "MODEL_OUTPUT_MISSING_SLIDES",
  "MODEL_OUTPUT_PARSE_FALLBACK_EMPTY",
  "SLIDE_INDEX_OUT_OF_RANGE",
  "SHAPE_ID_NOT_FOUND",
  "NO_MUTATION_FIELDS",
  "IMAGE_PREFETCH_FAILED",
  "IMAGE_INSERT_UNSUPPORTED",
  "TABLE_INSERT_FAILED",
  "CHART_INSERT_FAILED",
  "SHAPE_CREATE_FAILED",
  "SHAPE_MODIFY_FAILED",
  "SHAPE_DELETE_FAILED",
  "SLIDE_DUPLICATE_FAILED",
] as const;

const INTERNAL_REASON_LABEL_PATTERN = new RegExp(
  `\\b(?:${INTERNAL_REASON_LABELS.join("|")})\\b:?`,
  "g"
);

export function stripVisionLabel(text: string): string {
  return text.replace(/🔍\s*Vision Review:\s*/g, "").replace(/^Vision Review:\s*/gm, "").trim();
}

export function sanitizeUserFacingText(text: string | undefined): string {
  if (!text) {
    return "";
  }

  const cleaned = text
    .replace(INTERNAL_REASON_LABEL_PATTERN, "")
    .replace(/:\s*:/g, ": ")
    .replace(/[ \t]{2,}/g, " ")
    .replace(/\s+\n/g, "\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();

  return cleaned || text;
}
